import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { checkSession, redirectToApp } from '../services/auth'

// Pages where we should skip the auth redirect check
const SKIP_REDIRECT_PATHS = ['/terms', '/privacy', '/about']

// SessionStorage key to track if we've already checked
const SESSION_CHECK_KEY = 'nisa-auth-check-done'

/**
 * Hook to check if user is authenticated and redirect to main app
 * Runs once per session on marketing site load
 */
export const useAuthRedirect = () => {
  const location = useLocation()

  useEffect(() => {
    const performAuthCheck = async () => {
      // Skip if we're on a static page
      if (SKIP_REDIRECT_PATHS.includes(location.pathname)) {
        console.log(
          '[Auth] Skipping redirect check on static page:',
          location.pathname,
        )
        return
      }

      // Skip if we've already checked this session
      const alreadyChecked = sessionStorage.getItem(SESSION_CHECK_KEY)
      if (alreadyChecked === 'true') {
        console.log('[Auth] Already checked this session, skipping')
        return
      }

      console.log('[Auth] Starting auth redirect check...')

      // Mark as checked to prevent repeated checks
      sessionStorage.setItem(SESSION_CHECK_KEY, 'true')

      try {
        const { authenticated } = await checkSession()

        if (authenticated) {
          console.log('[Auth] User is authenticated, redirecting to app...')
          // User is logged in - redirect to app
          redirectToApp()
        } else {
          console.log(
            '[Auth] User is not authenticated, staying on marketing site',
          )
        }
      } catch (error) {
        // Fail silently - don't block the marketing site
        console.log('[Auth] Auth redirect check failed:', error)
      }
    }

    performAuthCheck()
  }, [location.pathname])
}
